import apiClient from "../../helpers/apiClient";

export const GET_HOME_BANNERS = "GET_HOME_BANNERS";
export const GET_HOME_BANNERS_REQUEST = "GET_HOME_BANNERS_REQUEST";
export const GET_HOME_BANNERS_SUCCESS = "GET_HOME_BANNERS_SUCCESS";
export const GET_HOME_BANNERS_FAILURE = "GET_HOME_BANNERS_FAILURE";

export const GET_TERM_AND_CONDITIONS = "GET_TERM_AND_CONDITIONS";
export const GET_TERM_AND_CONDITIONS_REQUEST =
  "GET_TERM_AND_CONDITIONS_REQUEST";
export const GET_TERM_AND_CONDITIONS_SUCCESS =
  "GET_TERM_AND_CONDITIONS_SUCCESS";
export const GET_TERM_AND_CONDITIONS_FAILURE =
  "GET_TERM_AND_CONDITIONS_FAILURE";

export const GET_REFERRAL = "GET_REFERRAL";
export const GET_REFERRAL_REQUEST = "GET_REFERRAL_REQUEST";
export const GET_REFERRAL_SUCCESS = "GET_REFERRAL_SUCCESS";
export const GET_REFERRAL_FAILURE = "GET_REFERRAL_FAILURE";

const initialState = {
  errorMessage: "",
  successMessage: ""
};

export const getHomeBanners = () => dispatch => {
  return dispatch({
    types: [
      GET_HOME_BANNERS_REQUEST,
      GET_HOME_BANNERS_SUCCESS,
      GET_HOME_BANNERS_FAILURE
    ],
    callAPI: config => apiClient.get(`Cms/GetHomeBanners`, config),
    payload: {}
  }).then(res => {
    // console.log("banners:", res);
  });
};

export const getTermsAndConditions = () => dispatch => {
  return dispatch({
    types: [
      GET_TERM_AND_CONDITIONS_REQUEST,
      GET_TERM_AND_CONDITIONS_SUCCESS,
      GET_TERM_AND_CONDITIONS_FAILURE
    ],
    callAPI: config => apiClient.get(`Cms/GetTermsAndConditions`, config),
    payload: {}
  });
};

export const getReferral = () => dispatch => {
  return dispatch({
    types: [GET_REFERRAL_REQUEST, GET_REFERRAL_SUCCESS, GET_REFERRAL_FAILURE],
    callAPI: config => apiClient.get(`Cms/GetReferral`, config),
    payload: {}
  });
};

export default function reducer(state = initialState, action) {
  const { errorMessage, successMessage, response } = action;
  switch (action.type) {
    case GET_HOME_BANNERS_REQUEST:
      return {
        ...state,
        successMessage: "",
        errorMessage: ""
      };
    case GET_HOME_BANNERS_SUCCESS:
      // console.log("banners:", response.data.result);
      return {
        ...state,
        banners: response.data.result,
        successMessage
      };
    case GET_HOME_BANNERS_FAILURE:
      return {
        ...state,
        errorMessage
      };

    case GET_TERM_AND_CONDITIONS_REQUEST:
      return {
        ...state,
        successMessage: "",
        errorMessage: ""
      };

    case GET_TERM_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        condition: response.data.result,
        successMessage
      };

    case GET_TERM_AND_CONDITIONS_FAILURE:
      return {
        ...state,
        errorMessage
      };

    case GET_REFERRAL_REQUEST:
      return {
        ...state,
        successMessage: "",
        errorMessage: ""
      };

    case GET_REFERRAL_SUCCESS:
      // console.log("conditions:", response.data.result);
      return {
        ...state,
        referral: response.data.result,
        successMessage
      };

    case GET_REFERRAL_FAILURE:
      return {
        ...state,
        errorMessage
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/Cms.js